<template>
  <div class="country-select">
    <div class="country-container">
      <div class="country-language-title">
        Language
      </div>
      <div>
        <LanguageSelect
          v-model="sourceLan"
          :options="languageStore.list"
          @update-model-value="handleLanguageChange"
        />
      </div>
      <div class="country-language-title country-Currency-title">
        Currency
      </div>
      <div>
        <CustomSelect
          v-model="selectedValue"
          :options="list"
          @update-model-value="emitFn"
        />
      </div>
      <div
        class="country-confirm"
        @click="saveCurrency"
      >
        Save
      </div>
    </div>
  </div>
</template>

<script setup>
import CustomSelect from '@/components/CustomSelect/index.vue'
import { useLanguageStore } from '@/pinia/language'
import LanguageSelect from './LanguageSelect.vue'
import { useCurrencyStore } from '@/pinia/currency'

const emit = defineEmits(['saved'])

const languageStore = useLanguageStore()

const sourceLan = ref('English')
const language = ref()

const currency = useCurrencyStore()

const selectedValue = ref(`${currency.current.targetCurrency} (${currency.current.targetCurrency.slice(0, 2)} ${currency.current.targetUnit})`)

const list = computed(() => currency.list.map(v => `${v.targetCurrency} (${v.targetCurrency.slice(0, 2)} ${v.targetUnit})`))

const emitFn = (e) => {
  selectedValue.value = e
}

const handleLanguageChange = (value) => {
  language.value = value
}

const saveCurrency = (event) => {
  languageStore.update(language.value)

  const selected = selectedValue.value.split(' ')[0]
  const data = currency.list.find((item) => item.targetCurrency === selected)
  currency.update(data)

  emit('saved')
}

const initSourceLan = () => {
  const current = languageStore.current
  language.value = current
  const target = languageStore.list.find(item => item.language === current)
  sourceLan.value = target.sourceLan
}

onMounted(() => {
  initSourceLan()
})
</script>

<style scoped lang="less">
.country-select {
  padding: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  .country-container {
    .country-language-title {
      font-family: mon-600;
      font-size: 12px;
      color: #232323;
      line-height: 16px;
      letter-spacing: -2%;
    }
    .country-Currency-title {
      margin-top: 16px;
    }
  }
  .country-item {
    width: 120px;
    background-color: #ffffff;
  }
  .exchange-rate {
    font-size: 11px;
    line-height: 14px;
    letter-spacing: -2%;
    font-family: mon-600;
    color: #232323;
    margin-top: 12px;
    .exchange-rate-unit {
      display: inline-block;
    }
    .exchange-rate-current {
      color: #052784;
    }
  }
  .exchange-desc {
    font-size: 9px;
    font-family: mon-400;
    line-height: 14px;
    letter-spacing: -2%;
    color: #6e717a;
  }
  .country-confirm {
    width: 100%;
    height: 32px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: mon-600;
    font-size: 12px;
    letter-spacing: -2%;
    text-align: center;
    line-height: 24px;
    color: #ffffff;
    background-color: rgba(5, 29, 132, 1);
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .country-confirm:hover {
    background-color: rgba(5, 29, 132, 0.9);
  }
  .country-confirm:active {
    background-color: rgba(5, 29, 132, 0.8);
    transform: scale(0.9);
  }
}
</style>
